/**
 * Shared primitive color tokens from Figma:
 * https://www.figma.com/design/6ZVGZowOXbrOXdrcQ9ji7y/Design-system?m=dev&node-id=0-1&vars=1&var-set-id=4-1873
 */
export const primitiveColors = {
    urbanOrange: {
        50: '#FFF5E5',
        100: '#FFEBCC',
        200: '#FFD699',
        300: '#FFC266',
        400: '#FFAD33',
        500: '#FF9900',
        550: '#EB8D00',
        600: '#CC7A00',
        700: '#995C00',
        800: '#663D00',
        900: '#331F00',
        950: '#190F00',
    },
    electricBlue: {
        50: '#F5FDFF',
        100: '#E6F9FF',
        200: '#CDF3FE',
        300: '#B9EEFE',
        400: '#A0E8FD',
        500: '#87E1FD',
        600: '#3BCFFC',
        700: '#04B2E7',
        800: '#037496',
        900: '#013A4B',
        950: '#011F28',
    },
    skydome: {
        50: '#E6F3F9',
        100: '#CEE8F3',
        200: '#9DD1E7',
        300: '#6BBADB',
        400: '#3AA2CF',
        500: '#287FA4',
        600: '#206583',
        700: '#184C62',
        800: '#103342',
        900: '#081921',
        950: '#040D10',
    },
    gray: {
        '000': '#000000',
        100: '#F9F9FB',
        200: '#F2F2F4',
        300: '#E1E1E7',
        400: '#BEBEC5',
        500: '#AEAEB7',
        600: '#909093',
        700: '#7C7C80',
        /** Secondary text: the lightest grey that reads at 4.5:1 on white, gray-100 and gray-200
         *  (WCAG AA for small text). gray-700 is 4.2:1 on white. */
        750: '#6E6E73',
        800: '#43434A',
        850: '#34343B',
        900: '#2A2A30',
        fff: '#FFFFFF',
    },
    green: {
        50: '#DFFBEC',
        100: '#BFF7D9',
        200: '#80EFB4',
        300: '#40E88E',
        400: '#19C86A',
        450: '#08B162',
        500: '#118A4A',
        600: '#0D6D3A',
        700: '#0A522C',
        800: '#07361D',
        900: '#031B0F',
        950: '#020E07',
    },
    red: {
        50: '#FCE9E8',
        100: '#F9D2D2',
        200: '#F3A6A5',
        300: '#EE7977',
        400: '#E84D4A',
        500: '#E11F1D',
        600: '#B51A17',
        700: '#720100',
        800: '#5A0D0C',
        900: '#2D0606',
        950: '#170303',
    },
    bruseRed: {
        50: '#FDEEED',
        100: '#FAD9D6',
        200: '#F5B3AD',
        300: '#F08D84',
        400: '#EC675B',
        500: '#E74133',
        600: '#C92618',
        700: '#971D12',
        800: '#64130C',
        900: '#320A06',
        950: '#1B0503',
    },
    defaDarkBlue: {
        50: '#E8E9F3',
        100: '#D0D4E6',
        200: '#A2A9CE',
        300: '#737EB5',
        400: '#4E5993',
        500: '#343C62',
        600: '#2A3150',
        700: '#20253C',
        800: '#151828',
        900: '#0B0C14',
        950: '#05060A',
    },
    defaBlue: {
        50: '#ECEFFD',
        100: '#DAE0FC',
        200: '#B4C1F8',
        300: '#8FA1F5',
        400: '#6982F1',
        500: '#4361EE',
        600: '#143AE0',
        700: '#0F2BA8',
        800: '#0A1D70',
        900: '#050E38',
        950: '#03071C',
    },
    defaBlueLight: '#6B85FF',
    defaRed: '#E11F1D',
    defaDarkRed: '#7F180F',
    defaDeepRed: '#3B0607',
    solar: '#FFCC00',
} as const;

export type PrimitiveColors = typeof primitiveColors;
